import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath } from "../../config/Constant";
import { doorKeyFailure, doorKeyRequest, doorKeySuccess, doorKeySupportedMethods } from "../Reducers/doorKeyReducer";
import { Alert } from "react-native";
import { setRenderFlashMessage } from "./appConfigAction";


export const getDigitalKeySupportedAuthMethods = (reservationNumber, locationId, otp) => {

  return async dispatch => {
    dispatch(doorKeyRequest());

    try {

      const sessionToken = await AsyncStorage.getItem('sessionToken');
      const guestToken = await AsyncStorage.getItem("guestToken")

      const payload = {
        header: {
          "sessionToken": sessionToken,
          "action": "requestSupportedMethods"
        },
        payload: {
          "locationId": locationId,
          "guestToken": guestToken,
          "reservationNumber": reservationNumber,
        },
      };


      const response = await clientConfigPath.post('guest/digitalKey', payload);


      const supportedMethods = response.data.payload.supportedMethods;
      dispatch(doorKeySuccess());
      if(supportedMethods){
        dispatch(doorKeySupportedMethods(supportedMethods))
      }
      console.log('response from digital Key', JSON.stringify(response.data.payload));

    } catch (error) {
      const response = error.response || {};
      // if (response.status === 401) {
      //   // Uncomment and implement wipeGuestData as needed
      //   // wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB === "true" });
      // }

      const errorMessage = response.data?.header?.status?.msg || `Something went wrong. Error - ${response.status}`;
      console.log("requestSupportedMethods api failed with error:", errorMessage);
      // Alert.alert('getDigital api failed', JSON.stringify(error?.message));

      dispatch(doorKeyFailure(errorMessage));
    }
  };
};
export const validateOTP = (reservationNumber, locationId, otp, callback) => {

  return async dispatch => {
    dispatch(doorKeyRequest());

    try {

      const sessionToken = await AsyncStorage.getItem('sessionToken');
      const guestToken = await AsyncStorage.getItem("guestToken")

      const payload = {
        header: {
          "sessionToken": sessionToken,
          "action": "validateOTP"
        },
        payload: {
          "locationId": locationId,
          "guestToken": guestToken,
          "reservationNumber": reservationNumber,
          "accessCode": otp
        },
      };


      const response = await clientConfigPath.post('guest/digitalKey', payload);
      callback(true, response?.data?.message);
      console.log('response sds', JSON.stringify(response?.data));
      dispatch(doorKeySuccess(response?.data?.payload));

    } catch (error) {
      const response = error.response || {};

      callback(false, response?.data?.message);

      const errorMessage = response.data?.payload || `Something went wrong. Error - ${response.status}`;
      console.log("validate otp api failed with error:", response?.data);

      dispatch(doorKeyFailure(errorMessage));
    }
  };
};




export const validateDigitalKey = (reservationNumber, locationId, action, callback) => {
  return async dispatch => {
    try {
      const sessionToken = await AsyncStorage.getItem('sessionToken');
      let guestToken = await AsyncStorage.getItem('guestToken');

      const response = await clientConfigPath.post('guest/digitalKey', {
        header: {
          "sessionToken": sessionToken,
          "action": action
        },
        payload: {
          "locationId": locationId,
          "guestToken": guestToken,
          "reservationNumber": reservationNumber
        }
      });

      console.log('validate api got response', response.data.payload);

      if (action === "validateStatus") {
        if (response.data?.header?.status?.code === "SUCCESS") {
          callback(true); // Success case
        } else {
          callback(false, response.data?.header?.status?.msg || "Unknown error"); // Failure case
        }
      } else {
        console.log('inside else for digi key');
        // Handle other action types if necessary
        callback(response.data?.payload?.issueKeyFlag, response.data?.payload?.message); // Success case
      }
    } catch (error) {
      const response = error.response || {};
      console.log('validateDigitalKey api failed', response.status);
      
      callback(false, response?.data?.header?.status?.msg || "Something went wrong");
      // Alert.alert('Validate Digital key api failed', JSON.stringify(error?.message));
    }
  };
};


export const requestOTP = (reservationNumber, locationId, callback) => {
  return async dispatch => {
    try {
      const sessionToken = await AsyncStorage.getItem('sessionToken');
      const guestToken = await AsyncStorage.getItem("guestToken")

      const payload = {
        header: {
          "sessionToken": sessionToken,
          "action": "requestOTP"
        },
        payload: {
          "locationId": locationId,
          "guestToken": guestToken,
          "reservationNumber": reservationNumber
        },
      };


      const response = await clientConfigPath.post('guest/digitalKey', payload);
      dispatch(doorKeySuccess(response))
      // Uncomment callback if needed
      callback(true, response.data.payload.message);
      console.log('response', response?.status);

    } catch (error) {
      const response = error.response || {};
      console.log('requestOTP api failed', JSON.stringify(error?.message));
      callback(false, JSON.stringify(error?.message));
    }
  };
};
